
import React from 'react';
import { Button } from '@/components/ui/button';
import { NavigateFunction } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

export const renderPrayerContent = (item: any, navigate: NavigateFunction) => {
  if (!item || !item.content) return <p>No content available</p>;

  return (
    <div className="space-y-4">
      {item.content.prayer && (
        <div>
          <h3 className="font-medium">Prayer:</h3>
          <p className="whitespace-pre-line">{item.content.prayer}</p>
        </div>
      )}
      
      {item.content.scriptures && Array.isArray(item.content.scriptures) && item.content.scriptures.length > 0 && (
        <div className="space-y-4">
          <h3 className="font-medium">Scriptures:</h3>
          {item.content.scriptures.map((scripture: any, i: number) => (
            <Card key={i} className="border-heaven-gold/10">
              <CardHeader className="py-3">
                <CardTitle className="text-md">{scripture.reference || `Scripture ${i+1}`}</CardTitle>
                <CardDescription className="mt-2">{scripture.text || 'No text available'}</CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      )}
      
      {item.content.voiceName && (
        <div>
          <h3 className="font-medium">Voice:</h3>
          <p>{item.content.voiceName}</p>
        </div>
      )}
      
      <Button
        onClick={() => navigate(`/prayer-generator`)}
        className="mt-4"
      >
        Go to Prayer Generator
      </Button>
    </div>
  );
};
